
import React from 'react';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import TranslatedText from '@/TranslatedText';

const BusinessSupport = () => {
  return (
    <Card className="mb-16">
      <CardHeader>
        <CardTitle><TranslatedText text="Business Support" /></CardTitle>
        <CardDescription>
          <TranslatedText text="Dedicated support options for our business customers" />
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-lg font-medium mb-2"><TranslatedText text="Enterprise Solutions" /></h3>
            <p className="text-muted-foreground mb-4">
              <TranslatedText text="Get personalized support and dedicated account management for your business needs." />
            </p>
            <Button variant="outline"><TranslatedText text="Contact Sales Team" /></Button>
          </div>
          <div>
            <h3 className="text-lg font-medium mb-2"><TranslatedText text="API & Integrations" /></h3>
            <p className="text-muted-foreground mb-4">
              <TranslatedText text="Technical support for API implementation and third-party integrations." />
            </p>
            <Button variant="outline"><TranslatedText text="View Developer Docs" /></Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BusinessSupport;
